export const COLLEGE_RECON_CONSTANTS = {
  passwordPattern:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+=\[\]{}|;:,.<>?-]).{8,}$/,
  guardWordTest: /^(?!.*\btest\b).*$/i,
  phoneMask: '(000) 000-0000',
  emailPattern: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/,
  invalidWebsite: 'Invalid Website',
  zipPattern: /^[0-9]{5}$/,
  phonePattern: /^[2-9]\d{2}[2-9]\d{6}$/,
  invalidPhone: 'Enter a valid 10-digit US phone number',
  invalidEmail: 'Invalid Email',
  dateFormat: 'MM/DD/YYYY',
  dateSaveFormat: 'YYYY-MM-DD',
  invalidPasswordStatement:
    'Password must be at least 8 characters including at least one uppercase letter, one lowercase letter, one number, and one special character',
  websitePattern:
    /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/,
  passwordMismatch: 'Password and Confirm Password should be same',
  invalidZipCode: 'Invalid Zip',
  userEncryptDecryptSecretKey: 'user-secret',
  userTypes: {
    user: 'user',
    collegeAdmin: 'collegeAdmin',
    superAdmin: 'superAdmin',
  },
  progressBar: {
    good: 80,
    medium: 50,
  },
};

export const ADMIN_USERS = [
  COLLEGE_RECON_CONSTANTS.userTypes.collegeAdmin,
  COLLEGE_RECON_CONSTANTS.userTypes.superAdmin,
];
